// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import Root from '../views/root/index.vue'
// import Home from '../views/web/navigationbar/home/index.vue'
// import Collection from '../views/web/navigationbar/collections/index.vue'
// import Discovery from '../views/web/navigationbar/discovery/index.vue'
// import User from '../views/web/navigationbar/userpage/index.vue'
// import Resource from '../views/web/sourceDetail/index.vue'
// import Login from '../views/web/auth/login/index.vue'
// import Bind from '../views/web/auth/bindPhone/index.vue'
// import Auth from '../views/web/auth/auth/index.vue'
// import Profile from '../views/web/profile/index.vue'
// import pic from '../views/web/sourceDetail/picdemo.vue'
// import Notfound from '../views/web/404/404.vue'
// import Single from '../views/web/navigationbar/collection/single.vue'
// // wap页面
// import Waphome from '../views/wap/home/index.vue'
// import Waplist from '../views/wap/sourcelist/index.vue'
// import Wapcertified from '../views/wap/sourceupload/certified.vue'
// import Wapcheck from '../views/wap/sourceupload/check.vue'
// import Waptranscode from '../views/wap/sourceupload/transcode.vue'
// import Wapdescription from '../views/wap/sourceupload/description.vue'
// import Wapdescriptioncheck from '../views/wap/sourceupload/descriptioncheck.vue'
// import Wapdetail from '../views/wap/detail/index.vue'
// import Wapuser from '../views/wap/user/mine/index.vue'
// import Wapuserupload from '../views/wap/user/upload/index.vue'
// import Waplogin from '../views/wap/login/login.vue'
// import Wapusercollection from '../views/wap/user/collection/index.vue'
// import Wapidentify from '../views/wap/identify/index.vue'
// import Wapprofile from '../views/wap/profile/index.vue'
// import Empty from '../views/wap/empty/index.vue'
// Vue.use(VueRouter)

// const routes = [
//   {
//     path: '/',
//     name: 'Root',
//     component: Root,
//     children: [{
//       path: '',
//       name: 'Home',
//       component: Home
//     },
//     {
//       path: '/newHome',
//       name: 'NewHome',
//       component: () => import('@/views/web/navigationbar/home/newHome.vue'),
//       meta: {
//         title: '数字特藏平台'
//       }
//     },
//      {
//       path: '/collection',
//       name: 'Collection',
//       component: Collection,
//       meta: {
//         title: '数字特藏平台'
//       }
//     }, {
//       path: '/discover',
//       name: 'Discovery',
//       component: Discovery,
//       meta: {
//         title: '数字特藏平台'
//       }
//     }, {
//       path: '/user',
//       name: 'User',
//       component: User,
//       meta: {
//         title: '数字特藏平台'
//       }
//     }, {
//       path: '/resource',
//       name: 'Resource',
//       component: Resource
//     }, {
//       path: '/privacy',
//       name: 'Profile',
//       component: Profile,
//       meta: {
//         title: '数字特藏平台'
//       }
//     }]
//   },
//   {
//     path: '/404',
//     component: () => import('@/views/404'),
//   },
 
//   {
//     path: '/login',
//     name: 'Login',
//     component: Login,
//     meta: {
//       title: '数字特藏平台'
//     }
//   }, {
//     path: '/pic',
//     name: 'pic',
//     component: pic
//   }, {
//     path: '/bind',
//     name: 'Bind',
//     component: Bind,
//     meta: {
//       title: '数字特藏平台'
//     }
//   }, {
//     path: '/auth',
//     name: 'Auth',
//     component: Auth,
//     meta: {
//       title: '数字特藏平台'
//     }
//   }, {
//     path: '/single',
//     name: 'Single',
//     component: Single,
//     meta: {
//       title: '数字特藏平台'
//     }
//   }, {
//     path: '/wap',
//     name: 'Waphome',
//     component: Waphome
//   }, {
//     path: '/wap/list',
//     name: 'Waplist',
//     component: Waplist
//   }, {
//     path: '/wap/upload',
//     name: 'Wapcertified',
//     component: Wapcertified
//   },{
//     path: '/wap/sourceupload/check',
//     name: 'Wapcheck',
//     component: Wapcheck
//   },{
//     path: '/wap/sourceupload/transcode',
//     name: 'Waptranscode',
//     component: Waptranscode
//   },{
//     path: '/wap/sourceupload/descriptioncheck',
//     name: 'Wapdescriptaioncheck',
//     component: Wapdescriptioncheck
//   },{
//     path: '/wap/sourceupload/description',
//     name: 'Wapdescriptaion',
//     component: Wapdescription
//   },{
//     path: '/wap/detail',
//     name: 'Wapdetail',
//     component: Wapdetail
//   }, {
//     path: '/wap/user',
//     name: 'Wapuser',
//     component: Wapuser
//   }, {
//     path: '/wap/user/upload',
//     name: 'Wapuserupload',
//     component: Wapuserupload
//   }, {
//     path: '/wap/user/collection',
//     name: 'Wapusercollection',
//     component: Wapusercollection
//   }, {
//     path: '/wap/identify',
//     name: 'Wapidentify',
//     component: Wapidentify
//   }, {
//     path: '/wap/login/',
//     name: 'Waplogin',
//     component: Waplogin
//   }, {
//     path: '/wap/profile',
//     name: 'Wapprofile',
//     component: Wapprofile
//   }, {
//     path: '/wap/empty',
//     name: 'Empty',
//     component: Empty
//   },
//   {
//     path: '/:pathMatch(.*)*',
//     name: '404',
//     component: Notfound
//   }
// ]

// const router = new VueRouter({
//   // mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

// export default router
import Vue from 'vue'
import VueRouter from 'vue-router'
import Root from '../views/root/index.vue'
import Home from '../views/web/navigationbar/home/index.vue'
import Collection from '../views/web/navigationbar/collections/index.vue'
import Discovery from '../views/web/navigationbar/discovery/index.vue'
import User from '../views/web/navigationbar/userpage/index.vue'
import Resource from '../views/web/sourceDetail/index.vue'
import Login from '../views/web/auth/login/index.vue'
import Bind from '../views/web/auth/bindPhone/index.vue'
import Auth from '../views/web/auth/auth/index.vue'
import Profile from '../views/web/profile/index.vue'
import pic from '../views/web/sourceDetail/picdemo.vue'
import Notfound from '../views/web/404/404.vue'
import Single from '../views/web/navigationbar/collection/single.vue'
import Special from '../views/web/special/index.vue'
import Specialdetail from '../views/web/special/detail.vue'
// wap页面
import Waphome from '../views/wap/home/index.vue'
import Waplist from '../views/wap/sourcelist/index.vue'
import Wapcertified from '../views/wap/sourceupload/certified.vue'
import Wapcheck from '../views/wap/sourceupload/check.vue'
import Waptranscode from '../views/wap/sourceupload/success.vue'
import Wapdescription from '../views/wap/sourceupload/description.vue'
import Wapdescriptioncheck from '../views/wap/sourceupload/descriptioncheck.vue'
import Wapdetail from '../views/wap/detail/index.vue'
import Wapuser from '../views/wap/user/mine/index.vue'
import Wapuserupload from '../views/wap/user/upload/index.vue'
import Waplogin from '../views/wap/login/login.vue'
import Wapusercollection from '../views/wap/user/collection/index.vue'
import Wapidentify from '../views/wap/identify/index.vue'
import Wapprofile from '../views/wap/profile/index.vue'
import Empty from '../views/wap/empty/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Root',
    component: Root,//Root,
    children: [{
      path: '',
      name: 'Home',
      component: () => import('@/views/web/navigationbar/home/newHome.vue'),
    },
    // {
    //     path: '/newHome',
    //     name: 'NewHome',
    //     component: () => import('@/views/web/navigationbar/home/newHome.vue'),
    //     meta: {
    //       title: '数字特藏平台'
    //     }
    //   },
    {
      path: '/collection',
      name: 'Collection',
      component: Collection,
      meta: {
        title: '数字特藏平台'
      }
    }, {
      path: '/discover',
      name: 'Discovery',
      component: Discovery,
      meta: {
        title: '数字特藏平台'
      }
    }, {
      path: '/user',
      name: 'User',
      component: User,
      meta: {
        title: '数字特藏平台'
      }
    }, {
      path: '/resource',
      name: 'Resource',
      component: Resource
    }, {
      path: '/privacy',
      name: 'Profile',
      component: Profile,
      meta: {
        title: '数字特藏平台'
      }
    },{
      path: '/special',
      name: 'Special',
      component: Special,
      meta: {
        title: '专题'
      }
    }]
  },
  {
    path: '/special/detail',
    name: 'Specialdetail',
    component: Specialdetail,
    meta: {
      title: '专题详情'
    }
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '数字特藏平台'
    }
  }, {
    path: '/pic',
    name: 'pic',
    component: pic
  }, {
    path: '/bind',
    name: 'Bind',
    component: Bind,
    meta: {
      title: '数字特藏平台'
    }
  }, {
    path: '/auth',
    name: 'Auth',
    component: Auth,
    meta: {
      title: '数字特藏平台'
    }
  }, {
    path: '/single',
    name: 'Single',
    component: Single,
    meta: {
      title: '数字特藏平台'
    }
  },  {
    path: '/wap',
    name: 'Waphome',
    component: Waphome
  }, {
    path: '/wap/list',
    name: 'Waplist',
    component: Waplist
  }, {
    path: '/wap/upload',
    name: 'Wapcertified',
    component: ()=>import('@/views/wap/sourceupload/certified.vue')
  },
  {
    path: '/wap/sourceupload/check',
    name: 'Wapcheck',
    component: Wapcheck
  },
  //H5资源转码
  {
    path: '/wap/transcoding',
    name: 'wapTranscoding',
    component: ()=>import('@/views/wap/sourceupload/transcoding.vue')
  },
  {
    path: '/wap/success',
    name: 'Wapsuccess',
    component: Waptranscode
  },{
    path: '/wap/descriptioncheck',
    name: 'Wapdescriptaioncheck',
    component: Wapdescriptioncheck
  },{
    path: '/wap/description',
    name: 'Wapdescriptaion',
    component: Wapdescription
  },{
    path: '/wap/detail',
    name: 'Wapdetail',
    component: Wapdetail
  }, {
    path: '/wap/user',
    name: 'Wapuser',
    component: Wapuser
  }, {
    path: '/wap/user/upload',
    name: 'Wapuserupload',
    component: Wapuserupload
  }, {
    path: '/wap/user/collection',
    name: 'Wapusercollection',
    component: Wapusercollection
  }, {
    path: '/wap/identify',
    name: 'Wapidentify',
    component: Wapidentify
  }, {
    path: '/wap/login/',
    name: 'Waplogin',
    component: Waplogin
  }, {
    path: '/wap/profile',
    name: 'Wapprofile',
    component: Wapprofile
  }, {
    path: '/wap/empty',
    name: 'Empty',
    component: Empty
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: Notfound
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
